import { Canvas, StaticCanvas } from 'fabric/fabric-impl';
import SnapToGrid from './snap-to-grid';

class Elements {
  getLeftTop(canvas: Canvas | StaticCanvas) {
    const viewport = canvas.viewportTransform;
    const zoom = canvas.getZoom();
    const left = SnapToGrid.roundByGrid(viewport ? (-1 * viewport[4]) / zoom + 20 : 20);
    const top = SnapToGrid.roundByGrid(viewport ? (-1 * viewport[5]) / zoom + 20 : 20);
    return { left, top };
  }
}

const elements = new Elements();
export default elements;
